const hashName = (name: string): number =>
    name
        .split("")
        .reduce((acc, c) => Math.imul(acc, 31) + c.charCodeAt(0), 0) >>> 0

const PERSON_AVATAR_TONE_CLASSES = [
    "bg-tone-lilac",
    "bg-tone-green",
    "bg-tone-blue",
    "bg-tone-cream",
] as const

export function getAvatarToneClass(name: string): string {
    return (
        PERSON_AVATAR_TONE_CLASSES[
            hashName(name) % PERSON_AVATAR_TONE_CLASSES.length
        ] ?? "bg-tone-lilac"
    )
}

export function getInitials(name: string): string {
    const parts = (name ?? "").trim().split(/\s+/)
    if (parts.length >= 2)
        return (
            (parts[0]?.[0] ?? "?") + (parts.at(-1)?.[0] ?? "?")
        ).toUpperCase()
    return (name[0] ?? "?").toUpperCase()
}
